import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";

const container: CSSProperties = {
  flex: 1,
};

const teamList: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: 14,
};

const menuPaper: CSSProperties = {
  maxWidth: 500,
};

const menuItemLabel: CSSProperties = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  padding: "0px 32px 0px 26px",
};

const inlineSelect: CSSProperties = {
  fontSize: 14,
  fontWeight: "bold",
  paddingLeft: 5,
};

const actionSection: CSSProperties = {};

const actionMenuItem: CSSProperties = {
  display: "flex",
  alignItems: "center",
  padding: "6px 40px 6px 15px",
  justifyContent: "flex-start",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: greys.paleGrey,
  },
};

const selectSubHeader: CSSProperties = {
  lineHeight: 1.5,
  padding: "12px 40px 5px 15px",
  fontSize: 14,
};

const actionIcons: CSSProperties = {
  width: "20px",
};

const actionLabel: CSSProperties = {
  paddingLeft: 12,
};

const divider: CSSProperties = {
  margin: "10px 0",
};

const listItem: CSSProperties = {
  cursor: "pointer",
  "&:hover": {
    backgroundColor: greys.paleGrey,
  },
};

export const styles = {
  container,
  menuPaper,
  menuItemLabel,
  inlineSelect,
  actionSection,
  selectSubHeader,
  actionMenuItem,
  actionIcons,
  actionLabel,
  teamList,
  divider,
  listItem,
};
